export default __webpack_public_path__ + "static/media/plans.eb6a9e5c.svg";